import { FC } from 'react';

import { Spinner, Row, Col } from 'react-bootstrap';

interface LoadingProps {
	size?: 'sm' | undefined;
}

export const Loading: FC<LoadingProps> = ({ size }) => (
	<Row>
		<Col>
			<Spinner animation="border" role="status" size={size}>
				<span className="visually-hidden">Carregando...</span>
			</Spinner>
		</Col>
	</Row>
);

export default Loading;
